// extracted by mini-css-extract-plugin
export default {"verticalMenu":"vertical-menu__verticalMenu","menuItem":"vertical-menu__menuItem"};